import { useState } from "react";

import { Condition } from "@types-runway/condition";

type ConditionName = Condition["product"]["name"];

export type StreamlinedSelection = {
  regionConditions: Condition[];
  setRegionConditions: React.Dispatch<React.SetStateAction<Condition[]>>;
  comfortCareConditions: Condition[];
  setComfortCareConditions: React.Dispatch<React.SetStateAction<Condition[]>>;
  hasSkippedComfortCare: boolean;
  setHasSkippedComfortCare: (hasSkipped: boolean) => void;
  committedConditionNames: ConditionName[];
  setCommittedConditionNames: (names: ConditionName[]) => void;
  clearSelection: () => void;
};

// What the patient chose on the streamlined treatment plan screen. It is held by the
// questionnaire, which outlives the screen, so the choices are still there when the patient
// comes back to the screen with the Back arrow.
const useStreamlinedSelection = (): StreamlinedSelection => {
  const [regionConditions, setRegionConditions] = useState<Condition[]>([]);
  const [comfortCareConditions, setComfortCareConditions] = useState<Condition[]>([]);
  const [hasSkippedComfortCare, setHasSkippedComfortCare] = useState(false);
  const [committedConditionNames, setCommittedConditionNames] = useState<ConditionName[]>([]);

  const clearSelection = () => {
    setRegionConditions([]);
    setComfortCareConditions([]);
    setHasSkippedComfortCare(false);
    setCommittedConditionNames([]);
  };

  return {
    regionConditions,
    setRegionConditions,
    comfortCareConditions,
    setComfortCareConditions,
    hasSkippedComfortCare,
    setHasSkippedComfortCare,
    committedConditionNames,
    setCommittedConditionNames,
    clearSelection,
  };
};

export default useStreamlinedSelection;
